<template>
	<transition name="viewer-fade">
		<div class="el-image-viewer__wrapper" :style="{ 'z-index': zIndex }">
			<div class="el-image-viewer__mask" @click="hide"></div>
			<!-- CLOSE -->
			<span class="el-image-viewer__btn el-image-viewer__close" @click="hide">
				<i class="el-icon-circle-close"></i>
			</span>
			<!-- ARROW -->
			<template v-if="!isSingle">
				<span class="el-image-viewer__btn el-image-viewer__prev"
					:class="{ 'is-disabled': !infinite && isFirst }" @click="prev">
					<i class="el-icon-arrow-left" />
				</span>
				<span class="el-image-viewer__btn el-image-viewer__next" :class="{ 'is-disabled': !infinite && isLast }"
					@click="next">
					<i class="el-icon-arrow-right" />
				</span>
			</template>
			<!-- 大图下方控制按钮区域 -->
			<div class="el-image-viewer__btn el-image-viewer__actions">
				<div class="el-image-viewer__actions__inner">
					<!--如果 非量子图片 && 是审计图片 && 存在修正图片 需要显示下面按钮 -->
					<div
						v-if="[0,1,2].indexOf(urlList[index].enType)>-1 && urlList[index].title === '审计图片' && urlList[index].correctFile">
						<!--如果存在修正图片，默认优先显示修正图片，此时显示'查看原图'-->
						<el-button @click="showCorrect = !showCorrect" style="color: white;" type="text" size="mini">
							{{showCorrect==false?'查看修正':'查看原图'}}
						</el-button>
					</div>
					<!--          <i @click="viewOriginalImage" v-if="urlList[index] && urlList[index].isSee != true" class="OriginalImage">查看原图</i>-->
					<i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
					<i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
					<i class="el-image-viewer__actions__divider"></i>
					<i :class="mode.icon" @click="toggleMode"></i>
					<i class="el-image-viewer__actions__divider"></i>
					<i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
					<i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
				</div>
			</div>
			<!-- CANVAS -->
			<div class="el-image-viewer__canvas">
				<!--
          伪代码：
          如果 (非量子加密 && 是审计图片 === true && 存在修正图片) {
            如果 ( showCorrect === true ){
                显示修正图片
            }else {
                显示原图片
            }
          }else{
            显示原图片
          }
        -->
				<img v-for="(item, i) in urlList" v-if="i === index" ref="img" class="el-image-viewer__img" :key="i"
					:src="([0,1,2].indexOf(urlList[index].enType) > -1&& urlList[index].title === '审计图片' && currentImg.correctFile)
		     ? (showCorrect==true  ? currentImg.correctFile[url]   : currentImg[url])  :currentImg[url] " :style="imgStyle"
					@load="handleImgLoad" @error="handleImgError" @mousedown="handleMouseDown">
			</div>
			
			<div class="lz-info" v-if="urlList[index].title&&urlList[index].error">
				<div class="box-arp">
					<div class="title">{{ urlList[index].title }}</div>
					<div class="Danger" v-if="urlList[index].error===-1">异常</div>
					<div class="Success" v-if="urlList[index].error===0">正常</div>
					<div class="Warning" v-if="urlList[index].error===1">警告</div>
				</div>
			</div>
			<div class="ortherInfo" >
				<div class="center">
					<div class="cli">
						<div class="title">申请单标题：</div>
						<div>{{applicationTitle}}</div>
					</div>
					<div class="cli" v-show="urlList[index].useType">
						<div class="title">用印模式：</div>
						<div>{{urlList[index].useType}}</div>
					</div>
					<div class="cli">
						<div class="title">图片类型：</div>
						<div>{{urlList[index].title}}</div>
					</div>
					<div class="cli">
						<div class="title">用印时间：</div>
						<div>{{urlList[index].createDate}}</div>
					</div>
					<div class="cli" v-show="urlList[index].useCount">
						<div class="title">用印次数：</div>
						<div>{{urlList[index].useCount}}</div>
					</div>
					<div class="cli">
						<div class="title">图片序号：</div>
						<div>{{index+1}}/{{urlList.length}}</div>
					</div>
				</div>
			</div>
		</div>
		
	</transition>
</template>

<script>
	import {
		mapGetters
	} from 'vuex';
	//非父子组件传值
	import {
		off,
		on
	} from 'element-ui/src/utils/dom';
	import {
		isFirefox,
		rafThrottle
	} from 'element-ui/src/utils/util';

	const Mode = {
		CONTAIN: {
			name: 'contain',
			icon: 'el-icon-full-screen'
		},
		ORIGINAL: {
			name: 'original',
			icon: 'el-icon-c-scale-to-original'
		}
	};
	const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';
	export default {
		name: 'elImageViewer',
		props: {
			url: {
				type: String,
				default: () => 'url'
			},
			correctFile: {
				type: String,
				default: () => ''
			},
			uuid: { //请求下个接口所带的参数变量
				type: String,
				default: () => 'uuid'
			},
			urlList: {
				type: Array,
				default: () => []
			},
			zIndex: {
				type: Number,
				default: 2000
			},
			onSwitch: {
				type: Function,
				default: () => {}
			},
			onClose: {
				type: Function,
				default: () => {}
			},
			showIndex: { //显示第几张图片
				type: Number,
				default: 0
			},
			loop: { //是否循环显示 默认开启
				type: Boolean,
				default: () => {
					return true
				}
			},
			applicationTitle: {//申请单标题
				type: String,
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				// 是否显示修正审计图片 true:显示修正的  false:不显示修正的
				showCorrect: false,
				index: 0,
				isShow: false,
				infinite: true,
				loading: false,
				mode: Mode.CONTAIN,
				transform: {
					scale: 1,
					deg: 0,
					offsetX: 0,
					offsetY: 0,
					enableTransition: false
				},
			};
		},
		computed: {
			...mapGetters(['userInfo', 'api', 'orgInfo']), //获取
			isSingle() {
				return this.urlList.length <= 1;
			},
			isFirst() {
				return this.index === 0;
			},
			isLast() {
				return this.index === this.urlList.length - 1;
			},
			currentImg() {
				console.log(this.urlList);
				return this.urlList[this.index];
			},
			imgStyle() {
				const {
					scale,
					deg,
					offsetX,
					offsetY,
					enableTransition
				} = this.transform;
				const style = {
					transform: `scale(${scale}) rotate(${deg}deg)`,
					transition: enableTransition ? 'transform .3s' : '',
					'margin-left': `${offsetX}px`,
					'margin-top': `${offsetY}px`
				};
				if (this.mode === Mode.CONTAIN) {
					style.maxWidth = style.maxHeight = '100%';
				}
				return style;
			}
		},
		watch: {
			index: {
				handler: function(val) {
					this.reset();
					this.onSwitch(val);
				}
			},
			currentImg(val) {
				this.$nextTick(_ => {
					const $img = this.$refs.img[0];
					if ($img && !$img.complete) {
						this.loading = true;
					}
				});
			}
		},
		mounted() {
			this.index = this.showIndex
			if (this.urlList) {
				this.urlList.forEach(item => {
					// 当前组件被加载时，处理一下传递过来的URL数组，将数组中的图片URL中的width参数去除，就可以显示大图了
					if (item.fileUrl && item.fileUrl.indexOf('&width=100')) {
						item.fileUrl = item.fileUrl.replace('&width=100', '')
					}
					// 当前组件被加载时，为每张审计图片添加属性 showCorrect 字段，代表是修正图片，当后面点击'查看原图时'，修改该字段为 false
					if ([0, 1, 2].indexOf(item.enType) > -1 && item.title === '审计图片' && item.correctFile) {
						item.correctFile.fileUrl = item.correctFile.fileUrl + "?Authorization=" + this.userInfo
							.token + "&us=web"
					}
				})
			}
			this.deviceSupportInstall();
		},
		methods: {
			showOtherInfoFn(){
				this.showOtherInfo=!this.showOtherInfo
			},
			hide() {
				this.deviceSupportUninstall();
				this.onClose();
			},
			deviceSupportInstall() {
				this._keyDownHandler = rafThrottle(e => {
					const keyCode = e.keyCode;
					switch (keyCode) {
						// ESC
						case 27:
							this.hide();
							break;
							// SPACE
						case 32:
							this.toggleMode();
							break;
							// LEFT_ARROW
						case 37:
							this.prev();
							break;
							// UP_ARROW
						case 38:
							this.handleActions('zoomIn');
							break;
							// RIGHT_ARROW
						case 39:
							this.next();
							break;
							// DOWN_ARROW
						case 40:
							this.handleActions('zoomOut');
							break;
					}
				});
				this._mouseWheelHandler = rafThrottle(e => {
					const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
					if (delta > 0) {
						this.handleActions('zoomIn', {
							zoomRate: 0.015,
							enableTransition: false
						});
					} else {
						this.handleActions('zoomOut', {
							zoomRate: 0.015,
							enableTransition: false
						});
					}
				});
				on(document, 'keydown', this._keyDownHandler);
				on(document, mousewheelEventName, this._mouseWheelHandler);
			},
			deviceSupportUninstall() {
				off(document, 'keydown', this._keyDownHandler);
				off(document, mousewheelEventName, this._mouseWheelHandler);
				this._keyDownHandler = null;
				this._mouseWheelHandler = null;
			},
			handleImgLoad(e) {
				this.loading = false;
			},
			handleImgError(e) {
				this.loading = false;
				e.target.alt = '加载失败';
			},
			handleMouseDown(e) {
				if (this.loading || e.button !== 0) return;
				const {
					offsetX,
					offsetY
				} = this.transform;
				const startX = e.pageX;
				const startY = e.pageY;
				this._dragHandler = rafThrottle(ev => {
					this.transform.offsetX = offsetX + ev.pageX - startX;
					this.transform.offsetY = offsetY + ev.pageY - startY;
				});
				on(document, 'mousemove', this._dragHandler);
				on(document, 'mouseup', ev => {
					off(document, 'mousemove', this._dragHandler);
				});
				e.preventDefault();
			},
			reset() {
				this.transform = {
					scale: 1,
					deg: 0,
					offsetX: 0,
					offsetY: 0,
					enableTransition: false
				};
			},
			toggleMode() {
				if (this.loading) return;

				const modeNames = Object.keys(Mode);
				const modeValues = Object.values(Mode);
				const index = modeValues.indexOf(this.mode);
				const nextIndex = (index + 1) % modeNames.length;
				this.mode = Mode[modeNames[nextIndex]];
				if (modeNames[nextIndex] == 'ORIGINAL') {
					this.transform = {
						scale: 1.1,
						deg: 0,
						offsetX: 0,
						offsetY: 0,
						enableTransition: false
					};
				} else {
					this.reset();
				}

			},
			prev() {
				if (this.isFirst && !this.infinite) return;
				const len = this.urlList.length;
				//判断是否开启循环
				if (this.loop) {
					this.index = (this.index - 1 + len) % len;
				} else {
					if (this.index == 0) {
						return
					}
					this.index--
				}
			},
			next() {
				if (this.isLast && !this.infinite) return;
				const len = this.urlList.length;
				//判断是否开启循环
				if (this.loop) {
					this.index = (this.index + 1) % len;
				} else {
					if (this.index == len - 1) {
						return
					}
					this.index++
				}
			},
			handleActions(action, options = {}) {
				if (this.loading) return;
				const {
					zoomRate,
					rotateDeg,
					enableTransition
				} = {
					zoomRate: 0.2,
					rotateDeg: 90,
					enableTransition: true,
					...options
				};
				const {
					transform
				} = this;
				switch (action) {
					case 'zoomOut':
						if (transform.scale > 0.2) {
							transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
						}
						break;
					case 'zoomIn':
						transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
						break;
					case 'clocelise':
						transform.deg += rotateDeg;
						break;
					case 'anticlocelise':
						transform.deg -= rotateDeg;
						break;
				}
				transform.enableTransition = enableTransition;
			}
		}
	};
</script>
<style scoped="scoped" lang="scss">
	@import "./imageViewer.scss";
	.ortherInfo{
		position: fixed;left: 20px; top: 20px;width: 200px;max-height:95%;overflow: auto;
		background-color: #4A4C57;border-radius: 10px;padding: 10px;
		.center{
			color: #fff;
			.cli{
				padding: 5px;font-size: 12px;display: flex;margin-bottom: 5px;
				line-height: 18px;
				.title{
					width: 75px;white-space: nowrap;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/imageViewer/imageViewer.vue